export default {
    email: 'Courriel',
    phone: 'Téléphone',
    sms: 'SMS',
};
